export default "__VITE_ASSET__OrYMc7cP__"